import React, { useEffect, useState } from "react";
import BasicCustomTable from "../../../component/basicTable";
import Linechart from "../../../component/lineChart";
import BarChartComp from "../../../component/barchart";
import BarChartVertical from "../../../component/verticalBarGraph";
import { FaDollarSign, FaMoneyBillWave, FaShoppingCart, FaUsers } from "react-icons/fa";
import DateFilter from "../../../component/dateFilter";
import dayjs from "dayjs";
import axiosInstance from "../../../configuration/request";
import { useSnackbar } from "../../../component/SnackbarContext";
import { serviceFormat } from "../../../constants/bussiness";

//  const summary = [
//   { title: "Total Revenue", value: "$22.16 Lac", icon: FaDollarSign },
//   { title: "Gross Revenue", value: "$14.98 Lac", icon: FaMoneyBillWave },
//   { title: "Total Orders", value: "769", icon: FaShoppingCart },
//   { title: "Total Customers", value: "320", icon: FaUsers },
// ];

  // const topStores = [
  //   { name: "Store A", value: 540000 },
  //   { name: "Store B", value: 320000 },
  //   { name: "Store C", value: 180000 },
  //   { name: "Store D", value: 120000 },
  //   { name: "Store E", value: 80000 },
  // ];

  // const servicesSales = [
  //   { name: "Dry Cleaning", value: 300000 },
  //   { name: "Tailoring", value: 250000 },
  //   { name: "Wash & Fold", value: 100000 },
  // ];

  // const overallSales = [
  //   { name: "2025-07-01", value: 10000 },
  //   { name: "2025-07-02", value: 12000 },
  //   { name: "2025-07-03", value: 18000 },
  //   { name: "2025-07-04", value: 15000 },
  //   { name: "2025-07-05", value: 22000 },
  // ];

  // const avgRatings = [
  //   { name: "Store A", value: 4.8 },
  //   { name: "Store B", value: 4.5 },
  //   { name: "Store C", value: 3 },
  //   { name: "Store D", value: 4.1 },
  //   { name: "Store E", value: 3.9 },
  // ];

  // const topOrders = [
  //   {
  //     customer: "John Doe",
  //     quantity: "10 Units",
  //     date: "2025-07-10",
  //     store: "Store A",
  //     price: "$5000",
  //   },
  //   {
  //     customer: "Jane Smith",
  //     quantity: "8 Units",
  //     date: "2025-07-09",
  //     store: "Store B",
  //     price: "$4000",
  //   },
  //   {
  //     customer: "Bob Lee",
  //     quantity: "6 Units",
  //     date: "2025-07-08",
  //     store: "Store C",
  //     price: "$3500",
  //   },
  //   {
  //     customer: "Alice Ray",
  //     quantity: "5 Units",
  //     date: "2025-07-07",
  //     store: "Store D",
  //     price: "$3000",
  //   },
  //   {
  //     customer: "Chris Kay",
  //     quantity: "4 Units",
  //     date: "2025-07-06",
  //     store: "Store E",
  //     price: "$2500",
  //   },
  // ];

  const orderColumns = [
    { field: "customer", label: "Customer" },
    // { field: "quantity", label: "Qty" },
    { field: "date", label: "Date" },
    { field: "store", label: "Store" },
    { field: "price", label: "Price" },
  ];



const Dashboard = () => {
  const [summary, setSummary] = useState([]);
const [topStores, setTopStores] = useState([]);
const [servicesSales, setServicesSales] = useState([]);
const [overallSales, setOverallSales] = useState([]);
const [avgRatings, setAvgRatings] = useState([]);
const [topOrders, setTopOrders] = useState([]);
const [isMetricsOpen, setIsMetricsOpen] = useState(false);
  const showSnackbar = useSnackbar();
    const [dateRange, setDateRange] = useState({
      startDate: dayjs().subtract(30, "day"),
      endDate: dayjs(),
    });

      useEffect(() => {
        fetchAnalytics(dateRange.startDate, dateRange.endDate);
      }, [dateRange]);
    
    const fetchAnalytics = (startDate, endDate) => {
  axiosInstance
    .get(`/customer/store/admin-analytics`, {
      params: {
        startDate: startDate.startOf('day').toISOString(),
        endDate: endDate.endOf('day').toISOString(),
      },
    })
    .then((res) => {
      const data = res?.data || {};
      setSummary(
        (data?.metrics || [])?.map((m, i) => {
          const icons = [FaDollarSign, FaMoneyBillWave, FaShoppingCart, FaUsers];
          return { ...m, icon: icons[i % icons.length] || FaDollarSign };
        })
      );
      setTopStores(data.topStores || []);

      setServicesSales(
        (data?.services || []).map((s) => ({
          ...s,
          name: serviceFormat(s.name), 
        }))
      );
        setAvgRatings(
        (data?.topRated || []).map((avg) => ({
          value:avg.averageRating,
          name: avg.name, 
        }))
      );
      setOverallSales(data?.chartData || []);
      setTopOrders(data?.topOrders || []);
    })
    .catch((err) => {
      showSnackbar("Something went wrong!", "error");
    });
};


    const handleRangeSelect = ({ startDate, endDate }) => {
      setDateRange({ startDate, endDate });
    };
  

  return (
    <div className="py-4 px-8 space-y-6">
       <div className="flex justify-between">
              <h1 className="text-2xl font-semibold text-[var(--primary-text-color)]">Analysis and Report</h1>
              <DateFilter onSelectRange={handleRangeSelect} />
            </div>
      {/* Metrics: focused top KPI + collapsible overview */}
      <div className="space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {[
            summary.find((m) => m?.title?.toLowerCase().includes("gross")),
            summary.find((m) => m?.title?.toLowerCase().includes("net")),
            summary.find((m) => m?.title?.toLowerCase().includes("total orders")),
          ].map((item, idx) => (
            <div
              key={`${item?.title || "metric"}-${idx}`}
              className={`relative overflow-hidden rounded-2xl px-4 py-3 shadow-md border ${
                idx % 2 === 0
                  ? "border-[#2D75A0] bg-gradient-to-br from-[#3383B2] via-[#2F7EAD] to-[#2A6E97] text-white"
                  : "border-[#CFE2F3] bg-gradient-to-br from-[#F5FAFF] via-[#EAF4FF] to-[#D8EBFF] text-[#0D2A42]"
              }`}
            >
              <div
                className={`absolute -top-6 -left-4 w-16 h-16 rounded-full ${
                  idx % 2 === 0 ? "bg-white/15" : "bg-[#3383B2]/10"
                }`}
              />
              <div
                className={`absolute bottom-0 right-2 w-12 h-12 rounded-full ${
                  idx % 2 === 0 ? "bg-white/10" : "bg-[#3383B2]/10"
                }`}
              />
              <div className={`absolute top-6 right-8 w-8 h-8 rounded-full ${idx % 2 === 0 ? "bg-white/20" : "bg-white/40"}`} />
              <div className={`text-xs uppercase tracking-wide ${idx % 2 === 0 ? "text-white/80" : "text-[#6C7D90]"}`}>
                {item?.title || "-"}
              </div>
              <div className={`text-2xl font-semibold mt-1 ${idx % 2 === 0 ? "text-white" : "text-[#0D2A42]"}`}>
                {item?.value ?? "-"}
              </div>
            </div>
          ))}
        </div>

        <div className="relative overflow-hidden rounded-2xl px-4 py-4 shadow-md border border-[#CFE2F3] bg-gradient-to-br from-white via-[#F7FBFF] to-[#E9F3FF]">
          <div className="absolute -top-10 right-4 w-24 h-24 bg-[#3383B2]/10 rounded-full" />
          <div className="absolute -bottom-8 left-8 w-20 h-20 bg-[#3383B2]/10 rounded-full" />
          <button
            type="button"
            className="w-full relative flex items-center justify-between"
            onClick={() => setIsMetricsOpen((prev) => !prev)}
          >
            <div className="font-semibold text-[15px] text-[var(--primary-text-color)]">
              Metrics Overview
            </div>
            <span className="text-[#1E6E9C] text-xl leading-none">
              {isMetricsOpen ? "−" : "+"}
            </span>
          </button>
          {isMetricsOpen && (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 relative mt-3">
              {summary.map((item, idx) => (
                <div
                  key={`overview-${item.title}-${idx}`}
                  className="rounded-xl border border-[#D8E8F7] bg-gradient-to-r from-white to-[#F1F8FF] px-3 py-2 shadow-sm"
                >
                  <div className="text-xs text-[#6C7D90] truncate">{item.title}</div>
                  <div className="text-base font-semibold text-[#0D2A42] mt-0.5">
                    {item.value ?? "-"}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* Graphs row */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="bg-white shadow rounded-2xl p-4">
          <div className="font-semibold mb-2">Top 5 Star Performing Stores</div>

          <BarChartVertical services={topStores} />
        </div>

        <div className="bg-white shadow rounded-2xl p-4">
          <div className="font-semibold mb-2">Services Based on Sales</div>
          <BarChartComp services={servicesSales} />
        </div>
      </div>

      {/* Overall sale */}
      <div className="bg-white shadow rounded-2xl p-4">
        <div className="font-semibold mb-2">Overall Sale Based on Date</div>
        <Linechart revenueTrends={overallSales} />
      </div>

      {/* Bottom row */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="bg-white shadow rounded-2xl p-4">
          <div className="font-semibold mb-2">Store Average Ratings Top 5</div>
          <BarChartComp services={avgRatings} />
        </div>

        <div className="bg-white shadow rounded-2xl p-4">
          <div className="font-semibold mb-2">Top 5 Most Valued Orders</div>
          <BasicCustomTable
            columns={orderColumns}
            rows={topOrders}
            colorHeader={true}
            customClassHeader="table-header-cell-colored"
            maxHeightClass="max-h-[220px]"
            // frontendPagination={true}
          />
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
